import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';
import { Container } from '../../../components';

export const ClusterInstallationMeterDataSkeleton = () => (
  <Container>
    <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
      <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
    </Stack>

    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
      <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
      <Skeleton variant="text" width={200} height={32} />
      <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
    </Stack>

    <Card sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Box>
            <Skeleton variant="text" width={250} height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={350} height={20} />
          </Box>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
          </Stack>
        </Stack>

        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2, mt: 2 }} />

        <Stack direction="row" spacing={2} sx={{ mt: 3, flexWrap: 'wrap', gap: 1 }}>
          {[1, 2, 3].map((item) => (
            <Stack key={item} direction="row" alignItems="center" spacing={1}>
              <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 0.5 }} />
              <Skeleton variant="text" width={150} height={24} />
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  </Container>
);
